import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { Component, ReactNode } from "react";

export default class MuiButton extends Component<LoadingButtonProps> {
  public render(): ReactNode {
    return <LoadingButton {...this.props} variant="contained" />;
  }
}
